var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { Availability } from "../Availability";
import { ModifierInstanceAvailabilityService } from "./ModifierInstanceAvailabilityService";
import { ProductTypeAvailabilityService } from "./ProductTypeAvailabilityService";
let ProductInstancePartAvailabilityService = class ProductInstancePartAvailabilityService {
    constructor(productTypeAvailabilityService, modifierInstanceAvailabilityService) {
        this.productTypeAvailabilityService = productTypeAvailabilityService;
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        makeImmutable(this);
    }
    availability(productInstancePart, parameterScope, fulfillmentTime) {
        const modifierAvailabilities = productInstancePart.modifierInstances.objects.map((modifierInstance) => this.modifierInstanceAvailabilityService.availability(modifierInstance, parameterScope));
        return Availability.composite([
            ...this.productTypeAvailabilityService.productTypeAvailability(productInstancePart.productType, parameterScope, fulfillmentTime),
            Availability.dependent("ModifierInstance", "", Availability.composite(modifierAvailabilities.raw)),
        ]);
    }
};
ProductInstancePartAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductTypeAvailabilityService !== "undefined" && ProductTypeAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _b : Object])
], ProductInstancePartAvailabilityService);
export { ProductInstancePartAvailabilityService };
